import generateAsyncRouteComponent from '../generateAsyncRouteComponent';

export default {
  path: 'contact',
  component: generateAsyncRouteComponent({
    loader: () => import('./containers/ContactPageContainer'),
  }),
};
